import { ValidateJSModel } from 'forms/shared/types';
import { MilitaryForeignModel } from './types';
import militaryForeignItemValidator from './validators/item';

const militaryForeignValidator: ValidateJSModel<MilitaryForeignModel> = {
  List: {
    presence: true,
    branchCollection: {
      validator: militaryForeignItemValidator,
    },
  },
  Comments: {},
  SummaryComments: {},
};

export default militaryForeignValidator;
